import { render, staticRenderFns } from "./BSCellTable.vue?vue&type=template&id=17fabbdf&"
import script from "./BSCellTable.vue?vue&type=script&lang=js&"
export * from "./BSCellTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports